// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@imgs/index/detail-top-bg-red.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes you-xin-detail_rotate__Yzfwb {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.you-xin-detail_loanApplication__FSxnd {
  padding-bottom: 21.333333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_top__EzXR8 {
  position: relative;
  height: 53.333333vw;
  background-size: 100% 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_header__kDSgx {
  border-bottom: none;
  color: #FFFFFF;
  background-color: transparent;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_block__LNZ8A {
  margin: 4.266667vw 4.266667vw 0;
  border-radius: 2.133333vw;
  padding: 5.333333vw 4.266667vw;
  background-color: #FFFFFF;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_block__LNZ8A.you-xin-detail_creditSesame__1quK5 {
  padding: 2.133333vw 4.266667vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_marginTop0__BQBhy {
  margin-top: 0 !important;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_borrowBox__T3kws {
  position: absolute;
  bottom: -8vw;
  left: 0;
  margin: 0 4.266667vw;
  border-radius: 2.133333vw;
  padding: 5.333333vw 4.266667vw;
  width: calc(100% - 8.533333vw);
  background-color: #FFFFFF;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_describe__fmZ1z {
  font-size: 3.733333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_inputBox__5Hk0H {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F0F0F0;
  padding-bottom: 2.133333vw;
  font-size: 9.6vw;
  font-weight: bold;
  line-height: 13.333333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_inputBox__5Hk0H .adm-input-element {
  font-size: 9.6vw;
  font-weight: bold;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_selectMonthBox__08XLk {
  margin-top: 4.266667vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_selectMonthBox__08XLk .you-xin-detail_select__Oualh {
  position: relative;
  padding-right: 5.333333vw;
  color: #BFBFBF;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_selectMonthBox__08XLk .you-xin-detail_select__Oualh.you-xin-detail_currentMonth__DvXKs {
  color: #262626;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_selectMonthBox__08XLk .you-xin-detail_select__Oualh {
  /* 右箭头 */
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_selectMonthBox__08XLk .you-xin-detail_select__Oualh::after {
  position: absolute;
  top: 34%;
  right: 0.8vw;
  border: 1px solid #BFBFBF;
  border-color: #BFBFBF #BFBFBF transparent transparent;
  width: 2.133333vw;
  height: 2.133333vw;
  content: "";
  transform: translateY(-50%) rotate(135deg);
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 {
  display: flex;
  margin-top: 12.266667vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div {
  flex: 1 1;
  position: relative;
  padding-left: 5.333333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div:first-child {
  padding-left: 0;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div:last-child::after {
  width: 0;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div::after {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 6.4vw;
  transform: translateY(-50%);
  content: "";
  background-color: #F0F0F0;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div .you-xin-detail_label__dFw\\+z {
  margin-bottom: 2;
  font-size: 3.2vw;
  color: #8C8C8C;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div .you-xin-detail_value__rlG7y {
  font-size: 4.266667vw;
  font-weight: 600;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_calculateBox__QC5E8 > div .you-xin-detail_grayColor__80jkT {
  color: #8C8C8C;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_footer__yOnq6 {
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 2.133333vw 4.266667vw;
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0 0 2.666667vw #DDDDDD;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_footer__yOnq6 .you-xin-detail_btn__1jIha {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 21.333333vw;
  width: 100%;
  height: 12.8vw;
  font-size: 4.266667vw;
  font-weight: bold;
  color: #FFFFFF;
  background: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_footer__yOnq6 .you-xin-detail_btn__1jIha::before {
  border-radius: 6.4vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_title__tJHtL {
  margin-top: 5.333333vw;
  margin-bottom: 2.133333vw;
  font-size: 3.733333vw;
  font-weight: 600;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_title__tJHtL:first-child {
  margin-top: 0;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_content__Ipc2y {
  font-size: 3.2vw;
  color: #595959;
  line-height: 4.533333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_content__Ipc2y + .you-xin-detail_content__Ipc2y {
  margin-top: 1.066667vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_askCondition__MUP3n {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -2.133333vw;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_askCondition__MUP3n > div {
  margin-bottom: 2.133333vw;
  width: 33.33%;
}
.you-xin-detail_loanApplication__FSxnd .you-xin-detail_askCondition__MUP3n > div .you-xin-detail_checkCircle__-xtjt {
  margin-right: 1.066667vw;
  font-size: 3.733333vw;
  color: #FF4D4F;
}

.you-xin-detail_monthBox__t12El {
  background-color: #F6F6F6;
}
.you-xin-detail_monthBox__t12El .you-xin-detail_row__swSnA {
  padding: 4.266667vw;
  font-size: 4.266667vw;
  text-align: center;
}
.you-xin-detail_monthBox__t12El .you-xin-detail_row__swSnA.you-xin-detail_active__PlwKL {
  font-weight: bold;
  color: #FF4D4F;
  background-color: #FFFFFF;
}

.you-xin-detail_resetModalContent__lN7aJ {
  border-radius: 2.666667vw;
  padding: 8vw 4.266667vw 5.333333vw;
  text-align: center;
  background: #FFFFFF;
  box-shadow: 0 2.4vw 7.466667vw 2.133333vw rgba(0, 0, 0, 0.05), 0 1.6vw 4.266667vw rgba(0, 0, 0, 0.08), 0 0.8vw 1.6vw -1.066667vw rgba(0, 0, 0, 0.12);
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_img__1q89i {
  width: 28.533333vw;
  height: 23.2vw;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_title__tJHtL {
  margin-bottom: 5.333333vw;
  font-size: 4.8vw;
  font-weight: bold;
  line-height: 6.666667vw;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productCon__Pkfxh {
  margin-bottom: 4.266667vw;
  border-radius: 1.066667vw;
  padding: 3.2vw;
  background: #FFF1F0;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_headline__L3gFm {
  font-weight: bold;
  color: #F19993;
  display: flex;
  justify-content: center;
  align-items: center;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_headline__L3gFm .you-xin-detail_moneyIcon__WtAh1 {
  position: relative;
  display: inline-block;
  margin: 0 3.2vw;
  border-radius: 100%;
  width: 4.266667vw;
  height: 4.266667vw;
  background: linear-gradient(132.88deg, #F2CAC7 4.51%, #FFE7E6 89%);
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_headline__L3gFm .you-xin-detail_moneyIcon__WtAh1::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.333333vw;
  height: 1.333333vw;
  background-color: #FFF1F0;
  content: "";
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU {
  margin-top: 3.2vw;
  border-radius: 1.066667vw;
  padding: 4.266667vw 3.2vw;
  text-align: left;
  background-color: #FFFFFF;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm .you-xin-detail_left__m-I5R {
  display: flex;
  align-items: center;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm .you-xin-detail_icon__a41xn {
  margin-right: 2.133333vw;
  border-radius: 1.066667vw;
  width: 6.4vw;
  height: 6.4vw;
  background: linear-gradient(180deg, #F2F4F6 0%, #E0E2E4 100%);
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm .you-xin-detail_name__0dsD- {
  font-size: 4.266667vw;
  line-height: 5.866667vw;
  font-weight: bold;
  color: #40404E;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm .you-xin-detail_amount__PXOkN {
  font-size: 5.866667vw;
  font-weight: bold;
  color: #FF5A0F;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_nameBox__sxmpm .you-xin-detail_amount__PXOkN .you-xin-detail_unit__KVG7h {
  margin-left: 1.066667vw;
  font-size: 3.2vw;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_rateDeadline__-2hR6 {
  margin-top: 2.666667vw;
  font-size: 3.2vw;
  color: #8C8C8C;
  display: flex;
  align-items: center;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_productInfo__1KrqU .you-xin-detail_rateDeadline__-2hR6 .you-xin-detail_line__gxAAb {
  display: inline-block;
  margin: 0 2.133333vw;
  width: 1px;
  height: 4.266667vw;
  background-color: #BFBFBF;
}
.you-xin-detail_resetModalContent__lN7aJ .you-xin-detail_btn__1jIha {
  border: none;
  padding: 0;
  height: 12.8vw;
  background: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);
  line-height: 13.333333vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/you-xin-detail/you-xin-detail.module.scss","webpack://./src/styles/mixin.scss","webpack://./src/styles/var.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC4KhB;EACE;IACE,uBAAA;ED1KF;EC6KA;IACE,yBAAA;ED3KF;AACF;AALA;EACE,2BAAA;AAOF;AALE;EACE,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yDAAA;AAOJ;AAJE;EACE,mBAAA;EACA,cEVU;EFWV,6BAAA;AAMJ;AAHE;EACE,+BAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBElBU;AFuBd;AAHI;EACE,8BAAA;AAKN;AADE;EACE,wBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,oBAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,yBErCU;AFuCd;AACE;EACE,qBAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAAJ;AAGM;EACE,gBAAA;EACA,iBAAA;AADR;AAME;EACE,sBAAA;ECyLF,aAAA;EAGE,8BAAA;EAIA,mBAAA;ADjMJ;AAKI;EACE,kBAAA;EACA,yBAAA;EACA,cEvCc;AFoCpB;AAKM;EACE,cEzEM;AFsEd;AAHI;EASE,QAAA;AAHN;AAIM;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,qDAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;AAFR;AAOE;EACE,aAAA;EACA,uBAAA;AALJ;AAOI;EACE,SAAA;EACA,kBAAA;EACA,wBAAA;AALN;AAOM;EACE,eAAA;AALR;AASQ;EACE,QAAA;AAPV;AAWM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;EACA,yBEzGK;AFgGb;AAYM;EACE,gBAAA;EACA,gBAAA;EACA,cEzGU;AF+FlB;AAaM;EACE,qBAAA;EACA,gBAAA;AAXR;AAcM;EACE,cElHU;AFsGlB;AAiBE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,8BAAA;EACA,WAAA;EACA,yBE/IU;EFgJV,kCAAA;AAfJ;AAiBI;ECqGF,aAAA;EAGE,uBAAA;EAIA,mBAAA;EDzGE,0BAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,cE1JQ;EF2JR,oEEtIY;AFwHlB;AAgBM;EACE,oBAAA;AAdR;AAmBE;EACE,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAjBJ;AAmBI;EACE,aAAA;AAjBN;AAqBE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;AAnBJ;AAqBI;EACE,sBAAA;AAnBN;AAuBE;EACE,aAAA;EACA,eAAA;EACA,0BAAA;AArBJ;AAuBI;EACE,yBAAA;EACA,aAAA;AArBN;AAuBM;EACE,wBAAA;EACA,qBAAA;EACA,cAAA;AArBR;;AA2BA;EACE,yBElMiB;AF0KnB;AA0BE;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACE,iBAAA;EACA,cExNU;EFyNV,yBErNQ;AF6Ld;;AA6BA;EACE,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBE9NY;EF+NZ,oJAAA;AA1BF;AA4BE;EACE,kBAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AA3BJ;AA8BE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBE9OQ;AFkNZ;AA+BE;EACE,iBAAA;EACA,cAAA;ECCF,aAAA;EAGE,uBAAA;EAIA,mBAAA;ADlCJ;AA8BI;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kEAAA;AA5BN;AA8BM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBEtQI;EFuQJ,WAAA;EACA,0DAAA;AA5BR;AAiCE;EACE,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBErRU;AFsPd;AAiCI;EChCF,aAAA;EAGE,8BAAA;EAIA,mBAAA;ADHJ;AA+BM;ECnCJ,aAAA;EAOE,mBAAA;ADCJ;AA+BM;EACE,wBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;AA7BR;AAgCM;EACE,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AA9BR;AAiCM;EACE,qBAAA;EACA,iBAAA;EACA,cAAA;AA/BR;AAiCQ;EACE,uBAAA;EACA,gBAAA;AA/BV;AAoCI;EACE,sBAAA;EACA,gBAAA;EACA,cE1SY;EDqOhB,aAAA;EAOE,mBAAA;AD8BJ;AAoCM;EACE,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBEvSY;AFqQpB;AAuCE;EACE,YAAA;EACA,UAAA;EACA,cAAA;EACA,oEEzTc;EF0Td,wBAAA;AArCJ","sourcesContent":["@import \"@/styles/var.scss\";\n@import \"@/styles/mixin.scss\";\n\n.loanApplication {\n  padding-bottom: 80px;\n\n  .top {\n    position: relative;\n    height: 200px;\n    background-size: 100% 100%;\n    background-image: url(\"~@imgs/index/detail-top-bg-red.png\");\n  }\n\n  .header {\n    border-bottom: none;\n    color: $color-white;\n    background-color: transparent;\n  }\n\n  .block {\n    margin: 16px 16px 0;\n    border-radius: 8px;\n    padding: 20px 16px;\n    background-color: $color-white;\n\n    &.creditSesame {\n      padding: 8px 16px;\n    }\n  }\n\n  .marginTop0 {\n    margin-top: 0 !important;\n  }\n\n  .borrowBox {\n    position: absolute;\n    bottom: -30px;\n    left: 0;\n    margin: 0 16px;\n    border-radius: 8px;\n    padding: 20px 16px;\n    width: calc(100% - 32px);\n    background-color: $color-white;\n  }\n\n  .describe {\n    font-size: 14px;\n  }\n\n  .inputBox {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid $line-color;\n    padding-bottom: 8px;\n    font-size: 36px;\n    font-weight: bold;\n    line-height: 50px;\n\n    :global {\n      .adm-input-element {\n        font-size: 36px;\n        font-weight: bold;\n      }\n    }\n  }\n\n  .selectMonthBox {\n    margin-top: 16px;\n\n    @include flex-sbc;\n\n    .select {\n      position: relative;\n      padding-right: 20px;\n      color: $placeholder-color;\n\n      &.currentMonth {\n        color: $color-black;\n      }\n\n      /* 右箭头 */\n      &::after {\n        position: absolute;\n        top: 34%;\n        right: 3px;\n        border: 1px solid $placeholder-color;\n        border-color: $placeholder-color $placeholder-color transparent transparent;\n        width: 8px;\n        height: 8px;\n        content: \"\";\n        transform: translateY(-50%) rotate(135deg);\n      }\n    }\n  }\n\n  .calculateBox {\n    display: flex;\n    margin-top: 46px;\n\n    >div {\n      flex: 1;\n      position: relative;\n      padding-left: 20px;\n\n      &:first-child {\n        padding-left: 0;\n      }\n\n      &:last-child {\n        &::after {\n          width: 0;\n        }\n      }\n\n      &::after {\n        position: absolute;\n        top: 50%;\n        right: 0;\n        width: 1px;\n        height: 24px;\n        transform: translateY(-50%);\n        content: \"\";\n        background-color: $line-color;\n      }\n\n      .label {\n        margin-bottom: 2;\n        font-size: 12px;\n        color: $text-gray-color;\n      }\n\n      .value {\n        font-size: 16px;\n        font-weight: 600;\n      }\n\n      .grayColor {\n        color: $text-gray-color;\n      }\n    }\n  }\n\n  .footer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    padding: 8px 16px;\n    width: 100%;\n    background-color: $color-white;\n    box-shadow: 0 0 10px #DDDDDD;\n\n    .btn {\n      @include flex-cc;\n\n      border-radius: 80px;\n      width: 100%;\n      height: 48px;\n      font-size: 16px;\n      font-weight: bold;\n      color: $color-white;\n      background: $linear-gradient;\n\n      &::before {\n        border-radius: 24px;\n      }\n    }\n  }\n\n  .title {\n    margin-top: 20px;\n    margin-bottom: 8px;\n    font-size: 14px;\n    font-weight: 600;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  .content {\n    font-size: 12px;\n    color: #595959;\n    line-height: 17px;\n\n    & + .content {\n      margin-top: 4px;\n    }\n  }\n\n  .askCondition {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: -8px;\n\n    >div {\n      margin-bottom: 8px;\n      width: 33.33%;\n\n      .checkCircle {\n        margin-right: 4px;\n        font-size: 14px;\n        color: #FF4D4F;\n      }\n    }\n  }\n}\n\n.monthBox {\n  background-color: $background-color;\n\n  .row {\n    padding: 16px;\n    font-size: 16px;\n    text-align: center;\n\n    &.active {\n      font-weight: bold;\n      color: $color-primary;\n      background-color: $color-white;\n    }\n  }\n}\n\n.resetModalContent {\n  border-radius: 10px;\n  padding: 30px 16px 20px;\n  text-align: center;\n  background: $color-white;\n  box-shadow: 0 9px 28px 8px rgb(0 0 0 / 5%), 0 6px 16px rgb(0 0 0 / 8%), 0 3px 6px -4px rgb(0 0 0 / 12%);\n\n  .img {\n    width: 107px;\n    height: 87px;\n  }\n\n  .title {\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: bold;\n    line-height: 25px;\n  }\n\n  .productCon {\n    margin-bottom: 16px;\n    border-radius: 4px;\n    padding: 12px;\n    background: $light-red;\n  }\n\n  .headline {\n    font-weight: bold;\n    color: #F19993;\n\n    @include flex-cc;\n\n    .moneyIcon {\n      position: relative;\n      display: inline-block;\n      margin: 0 12px;\n      border-radius: 100%;\n      width: 16px;\n      height: 16px;\n      background: linear-gradient(132.88deg, #F2CAC7 4.51%, #FFE7E6 89%);\n\n      &::after {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 5px;\n        height: 5px;\n        background-color: $light-red;\n        content: \"\";\n        transform: translateX(-50%) translateY(-50%) rotate(45deg);\n      }\n    }\n  }\n\n  .productInfo {\n    margin-top: 12px;\n    border-radius: 4px;\n    padding: 16px 12px;\n    text-align: left;\n    background-color: $color-white;\n\n    .nameBox {\n      @include flex-sbc;\n\n      .left {\n        @include flex-vc;\n      }\n\n      .icon {\n        margin-right: 8px;\n        border-radius: 4px;\n        width: 24px;\n        height: 24px;\n        background: linear-gradient(180deg, #F2F4F6 0%, #E0E2E4 100%);\n      }\n\n      .name {\n        font-size: 16px;\n        line-height: 22px;\n        font-weight: bold;\n        color: #40404E;\n      }\n\n      .amount {\n        font-size: 22px;\n        font-weight: bold;\n        color: #FF5A0F;\n\n        .unit {\n          margin-left: 4px;\n          font-size: 12px;\n        }\n      }\n    }\n\n    .rateDeadline {\n      margin-top: 10px;\n      font-size: 12px;\n      color: $text-gray-color;\n\n      @include flex-vc;\n\n      .line {\n        display: inline-block;\n        margin: 0 8px;\n        width: 1px;\n        height: 16px;\n        background-color: $placeholder-color;\n      }\n    }\n  }\n\n  .btn {\n    border: none;\n    padding: 0;\n    height: 48px;\n    background: $linear-gradient;\n    line-height: 50px;\n  }\n}\n","@charset \"UTF-8\";\n\n// 圆圈\n@mixin circle($width) {\n  display: inline-block;\n  border-radius: 50%;\n  width: $width;\n  height: $width;\n}\n\n// 省略号样式\n@mixin ellipsis($lineNum: \"\") {\n  overflow: hidden;\n\n  @if $lineNum != \"\" {\n    /* stylelint-disable-next-line */\n    display: -webkit-box;\n    /* stylelint-disable-next-line */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: $lineNum;\n  } @else {\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n// css箭头\n@mixin arrow($direction, $width, $height, $color) {\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  @if $direction == \"top\" {\n    border-top: 0;\n    border-right: solid $width transparent;\n    border-bottom: solid $height $color;\n    border-left: solid $width transparent;\n  } @else if $direction == \"bottom\" {\n    border-top: solid $height $color;\n    border-right: solid $width transparent;\n    border-bottom: 0;\n    border-left: solid $width transparent;\n  } @else if $direction == \"left\" {\n    border-top: solid $height transparent;\n    border-right: solid $width $color;\n    border-bottom: solid $height transparent;\n    border-left: 0;\n  } @else if $direction == \"right\" {\n    border-top: solid $height transparent;\n    border-right: 0;\n    border-bottom: solid $height transparent;\n    border-left: solid $width $color;\n  }\n}\n\n// 上下左右居中，为解决被外部数据覆盖的问题，强制使用!important\n@mixin setXYMiddle($width, $height) {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  margin-top: -$height / 2 !important;\n  margin-left: -$width / 2 !important;\n  width: $width !important;\n  min-width: unset;\n  height: $height !important;\n}\n\n// 上下居中\n@mixin setYMiddle($height) {\n  position: absolute;\n  top: 50%;\n  margin-top: -$height / 2;\n  height: $height;\n}\n\n// 左右居中\n@mixin setXMiddle($width) {\n  position: absolute;\n  left: 50%;\n  margin-left: -$width / 2;\n  width: $width;\n}\n\n// 切换动画\n@mixin transition($type) {\n  transition: .3s $type;\n}\n\n// 按钮公共样式\n@mixin btn-normal($color) {\n  @include transition(background-color);\n\n  border-color: $color;\n  border-radius: 20px;\n  width: 90px;\n  height: 40px;\n  font-size: $font-size-14;\n  text-align: center;\n  color: $color-FFFFFF;\n  background: $color;\n  line-height: 40px;\n  cursor: pointer;\n  user-select: none;\n}\n\n// 失效状态，强制使用同一种颜色\n@mixin disable($type, $color) {\n  cursor: not-allowed !important;\n\n  @if $type == \"color\" {\n    color: $color !important;\n\n    &:hover {\n      color: $color !important;\n    }\n\n    &:active {\n      color: $color !important;\n    }\n  } @else if $type == \"background-color\" {\n    background-color: $color !important;\n\n    &:hover {\n      background-color: $color !important;\n    }\n\n    &:active {\n      background-color: $color !important;\n    }\n  }\n}\n\n// 全局阴影效果\n@mixin shadow {\n  box-shadow: 0 0 10px 2px rgba(#5E5C5C, .25);\n}\n\n// 变色样式\n@mixin action-green($type) {\n  @include transition($type);\n\n  cursor: pointer;\n\n  @if $type == \"color\" {\n    &:hover {\n      color: $color-55DE99 !important;\n    }\n\n    &:active {\n      color: $color-22B76B !important;\n    }\n  } @else if $type == \"background-color\" {\n    &:hover {\n      background-color: $color-55DE99 !important;\n    }\n\n    &:active {\n      background-color: $color-22B76B !important;\n    }\n  }\n}\n\n// 清除浮动\n@mixin clearfix {\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 旋转\n@mixin animation-rotate() {\n  animation-duration: 1s;\n  animation-name: rotate;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(1, 1, 1, 1);\n}\n\n// 文本n行溢出隐藏显示...\n@mixin ellipsis-basic($n) {\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: $n;\n  -webkit-line: $n;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n// 文本不换行\n@mixin no-wrap {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// 宽高\n@mixin wh($w: 100%, $h: 100%) {\n  width: $w;\n  height: $h;\n}\n\n// 跳转文字 有hover效果\n@mixin link($color: $text-grey-color, $hover-color: $text-grey-color) {\n  position: relative;\n  color: $color;\n  cursor: pointer;\n  user-select: none;\n\n  @content;\n\n  &:hover {\n    color: $hover-color;\n  }\n}\n\n// 跳转文字 带下划线 有hover效果\n@mixin link-underline($color: $text-grey-color, $hover-color: $text-grey-color) {\n  @include link($color, $hover-color) {\n    &:hover {\n      &::after {\n        border-bottom-color: $hover-color;\n      }\n    }\n\n    &::after {\n      position: absolute;\n      bottom: 0;\n      content: \"\";\n      left: 0;\n      border-bottom: 1px solid $color;\n      width: 100%;\n    }\n  }\n}\n\n// flex 布局\n@mixin flex($obj) {\n  display: flex;\n\n  @if map-get($obj, \"justify\") {\n    justify-content: map-get($obj, \"justify\");\n  }\n\n  @if map-get($obj, \"align\") {\n    align-items: map-get($obj, \"align\");\n  }\n}\n\n// flex 水平居中\n@mixin flex-c {\n  @include flex((justify: center));\n}\n\n// flex 垂直居中\n@mixin flex-vc {\n  @include flex((align: center));\n}\n\n// flex 水平两端对齐\n@mixin flex-sb {\n  @include flex((justify: space-between));\n}\n\n// flex 水平垂直居中\n@mixin flex-cc {\n  @include flex((justify: center, align: center));\n}\n\n// flex 水平两端对齐，垂直居中\n@mixin flex-sbc {\n  @include flex((justify: space-between, align: center));\n}","// 公共颜色\n$color-primary: #FF4D4F;\n\n// 主字色\n$color-black: #262626;\n$color-white: #FFFFFF;\n\n// 浅红\n$light-red: #FFF1F0;\n\n// 浅红背景\n$light-red-bg: #FFF3F4;\n\n// 背景色\n$background-color: #F6F6F6;\n\n// 线条颜色\n$line-color: #F0F0F0;\n\n// 边框颜色\n$border-color: #D9D9D9;\n\n// 文字灰色颜色\n$text-gray-color: #8C8C8C;\n\n// 渐变色\n$linear-gradient: linear-gradient(108.61deg, #FF606E 3.46%, #FF192C 97.1%);\n\n// skin12字体颜色\n$text-skin12: #684aff;\n\n// skin12渐变色\n$linear-gradient-skin12: linear-gradient(1turn, #a18eff, #684aff);\n\n// 占位符颜色\n$placeholder-color: #BFBFBF;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loanApplication": `you-xin-detail_loanApplication__FSxnd`,
	"top": `you-xin-detail_top__EzXR8`,
	"header": `you-xin-detail_header__kDSgx`,
	"block": `you-xin-detail_block__LNZ8A`,
	"creditSesame": `you-xin-detail_creditSesame__1quK5`,
	"marginTop0": `you-xin-detail_marginTop0__BQBhy`,
	"borrowBox": `you-xin-detail_borrowBox__T3kws`,
	"describe": `you-xin-detail_describe__fmZ1z`,
	"inputBox": `you-xin-detail_inputBox__5Hk0H`,
	"selectMonthBox": `you-xin-detail_selectMonthBox__08XLk`,
	"select": `you-xin-detail_select__Oualh`,
	"currentMonth": `you-xin-detail_currentMonth__DvXKs`,
	"calculateBox": `you-xin-detail_calculateBox__QC5E8`,
	"label": `you-xin-detail_label__dFw+z`,
	"value": `you-xin-detail_value__rlG7y`,
	"grayColor": `you-xin-detail_grayColor__80jkT`,
	"footer": `you-xin-detail_footer__yOnq6`,
	"btn": `you-xin-detail_btn__1jIha`,
	"title": `you-xin-detail_title__tJHtL`,
	"content": `you-xin-detail_content__Ipc2y`,
	"askCondition": `you-xin-detail_askCondition__MUP3n`,
	"checkCircle": `you-xin-detail_checkCircle__-xtjt`,
	"monthBox": `you-xin-detail_monthBox__t12El`,
	"row": `you-xin-detail_row__swSnA`,
	"active": `you-xin-detail_active__PlwKL`,
	"resetModalContent": `you-xin-detail_resetModalContent__lN7aJ`,
	"img": `you-xin-detail_img__1q89i`,
	"productCon": `you-xin-detail_productCon__Pkfxh`,
	"headline": `you-xin-detail_headline__L3gFm`,
	"moneyIcon": `you-xin-detail_moneyIcon__WtAh1`,
	"productInfo": `you-xin-detail_productInfo__1KrqU`,
	"nameBox": `you-xin-detail_nameBox__sxmpm`,
	"left": `you-xin-detail_left__m-I5R`,
	"icon": `you-xin-detail_icon__a41xn`,
	"name": `you-xin-detail_name__0dsD-`,
	"amount": `you-xin-detail_amount__PXOkN`,
	"unit": `you-xin-detail_unit__KVG7h`,
	"rateDeadline": `you-xin-detail_rateDeadline__-2hR6`,
	"line": `you-xin-detail_line__gxAAb`,
	"rotate": `you-xin-detail_rotate__Yzfwb`
};
export default ___CSS_LOADER_EXPORT___;
